module.exports = __webpack_public_path__ + "img/Master Guardian Elite.b5aa93f0.png";